export default {"src":"/_next/static/media/account-roles-icon.4d20bf7c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};